interface AxiosLikeError {
  isAxiosError?: boolean;
  response?: {
    status?: number;
    data?: {
      message?: unknown;
    };
  };
}

function asAxiosLikeError(error: unknown): AxiosLikeError | null {
  if (typeof error !== "object" || error === null) {
    return null;
  }

  if ((error as AxiosLikeError).isAxiosError !== true) {
    return null;
  }

  return error as AxiosLikeError;
}

export function readApiStatus(error: unknown): number | null {
  return asAxiosLikeError(error)?.response?.status ?? null;
}

export function readApiErrorMessage(error: unknown, fallback: string): string {
  const message = asAxiosLikeError(error)?.response?.data?.message;
  if (typeof message === "string" && message.trim()) {
    return message.trim();
  }

  return fallback;
}
